module.exports = __webpack_public_path__ + "media/images/user-input-2f51b89bc1a7c68feaf8e5aad39e2b9e.svg";